import { render, staticRenderFns } from "./Hongkong.vue?vue&type=template&id=694a2cb4&"
import script from "./Hongkong.vue?vue&type=script&lang=js&"
export * from "./Hongkong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694a2cb4')) {
      api.createRecord('694a2cb4', component.options)
    } else {
      api.reload('694a2cb4', component.options)
    }
    module.hot.accept("./Hongkong.vue?vue&type=template&id=694a2cb4&", function () {
      api.rerender('694a2cb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Hongkong.vue"
export default component.exports